import Vue from "vue";
import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/functions";
import "@firebase/storage";
import config from "../config/firebase-staging.json";

firebase.initializeApp(config);

const db = firebase.firestore();
db.enablePersistence();
const auth = firebase.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);

const functions = firebase.functions();

const storage = firebase.storage();

Vue.prototype.$auth = auth;
Vue.prototype.$db = db;
Vue.prototype.$functions = functions;
Vue.prototype.$storage = storage;

export { auth, db, functions, storage };
